import appState from './app/state'
import componentsState from './components/state'
import draggableState from './draggable/state'
import settingsState from './settings/state'

const store = {
  appState,
  componentsState,
  draggableState,
  settingsState
}

export default store
